import extend from './extend';
export var ConferenceType;
(function (ConferenceType) {
    ConferenceType[ConferenceType["Web"] = 1] = "Web";
    ConferenceType[ConferenceType["Telephone"] = 2] = "Telephone";
    ConferenceType[ConferenceType["WebAndPhone"] = 3] = "WebAndPhone";
    ConferenceType[ConferenceType["InPerson"] = 4] = "InPerson";
})(ConferenceType || (ConferenceType = {}));
const conferenceTypeMap = new Map([
    [ConferenceType.Web, { name: 'Web' }],
    [ConferenceType.Telephone, { name: 'Telephone' }],
    [ConferenceType.WebAndPhone, { name: 'Web + Phone' }],
    [ConferenceType.InPerson, { name: 'In-person' }],
]);
export var ConferenceMediaType;
(function (ConferenceMediaType) {
    ConferenceMediaType[ConferenceMediaType["Video"] = 1] = "Video";
    ConferenceMediaType[ConferenceMediaType["Voice"] = 2] = "Voice";
})(ConferenceMediaType || (ConferenceMediaType = {}));
const conferenceMediaTypeMap = new Map([
    [ConferenceMediaType.Video, { name: 'Video' }],
    [ConferenceMediaType.Voice, { name: 'Voice' }],
]);
export var ConferencePlatform;
(function (ConferencePlatform) {
    ConferencePlatform[ConferencePlatform["Sentiment"] = 1] = "Sentiment";
    ConferencePlatform[ConferencePlatform["OffPlatform"] = 2] = "OffPlatform";
})(ConferencePlatform || (ConferencePlatform = {}));
const conferencePlatformMap = new Map([
    [ConferencePlatform.Sentiment, { name: 'Sentiment' }],
    [ConferencePlatform.OffPlatform, { name: 'Off Platform' }],
]);
export var ConferenceFeatureShareType;
(function (ConferenceFeatureShareType) {
    ConferenceFeatureShareType[ConferenceFeatureShareType["EnabledForModerator"] = 1] = "EnabledForModerator";
    ConferenceFeatureShareType[ConferenceFeatureShareType["EnabledForModeratorAndRespondent"] = 2] = "EnabledForModeratorAndRespondent";
    ConferenceFeatureShareType[ConferenceFeatureShareType["EnabledForAll"] = 3] = "EnabledForAll";
    ConferenceFeatureShareType[ConferenceFeatureShareType["DisabledForAll"] = 4] = "DisabledForAll";
})(ConferenceFeatureShareType || (ConferenceFeatureShareType = {}));
const conferenceFeatureShareMap = new Map([
    [ConferenceFeatureShareType.EnabledForModerator, { name: 'Enabled for Moderator' }],
    [ConferenceFeatureShareType.EnabledForModeratorAndRespondent, { name: 'Enabled for Moderator + Respondent' }],
    [ConferenceFeatureShareType.EnabledForAll, { name: 'Enabled for All' }],
    [ConferenceFeatureShareType.DisabledForAll, { name: 'Disabled for All' }],
]);
export var ConferenceCue;
(function (ConferenceCue) {
    ConferenceCue[ConferenceCue["EnterPin"] = 1] = "EnterPin";
    ConferenceCue[ConferenceCue["InvalidPin"] = 2] = "InvalidPin";
    ConferenceCue[ConferenceCue["Joined"] = 3] = "Joined";
    ConferenceCue[ConferenceCue["NoInput"] = 4] = "NoInput";
    ConferenceCue[ConferenceCue["NotAuthorized"] = 5] = "NotAuthorized";
    ConferenceCue[ConferenceCue["Recording"] = 6] = "Recording";
    ConferenceCue[ConferenceCue["UnableToConnect"] = 7] = "UnableToConnect";
    ConferenceCue[ConferenceCue["WelcomeEnterPin"] = 8] = "WelcomeEnterPin";
    ConferenceCue[ConferenceCue["WaitingRoomForApproval"] = 9] = "WaitingRoomForApproval";
    ConferenceCue[ConferenceCue["WaitingRoomForStart"] = 10] = "WaitingRoomForStart";
})(ConferenceCue || (ConferenceCue = {}));
const conferenceCueMap = new Map([
    [ConferenceCue.EnterPin, { name: 'Enter Pin' }],
    [ConferenceCue.InvalidPin, { name: 'Invalid Pin' }],
    [ConferenceCue.Joined, { name: 'Joined' }],
    [ConferenceCue.NoInput, { name: 'No Input' }],
    [ConferenceCue.NotAuthorized, { name: 'Not Authorized' }],
    [ConferenceCue.Recording, { name: 'Recording' }],
    [ConferenceCue.UnableToConnect, { name: 'Unable To Connect' }],
    [ConferenceCue.WelcomeEnterPin, { name: 'Welcome Enter Pin' }],
    [ConferenceCue.WaitingRoomForApproval, { name: 'Waiting Room for Approval' }],
    [ConferenceCue.WaitingRoomForStart, { name: 'Waiting Room for Start' }],
]);
export default {
    ConferenceType: extend(conferenceTypeMap),
    ConferenceMediaType: extend(conferenceMediaTypeMap),
    ConferencePlatform: extend(conferencePlatformMap),
    ConferenceFeatureShareType: extend(conferenceFeatureShareMap),
    ConferenceCue: extend(conferenceCueMap),
};
export var ConferenceChatType;
(function (ConferenceChatType) {
    ConferenceChatType[ConferenceChatType["Group"] = 1] = "Group";
    ConferenceChatType[ConferenceChatType["Direct"] = 2] = "Direct";
})(ConferenceChatType || (ConferenceChatType = {}));
export var ConferenceTagType;
(function (ConferenceTagType) {
    ConferenceTagType[ConferenceTagType["Project"] = 1] = "Project";
    ConferenceTagType[ConferenceTagType["UserCreated"] = 2] = "UserCreated";
    ConferenceTagType[ConferenceTagType["Module"] = 3] = "Module";
    ConferenceTagType[ConferenceTagType["Global"] = 4] = "Global";
    ConferenceTagType[ConferenceTagType["Segmentation"] = 5] = "Segmentation";
})(ConferenceTagType || (ConferenceTagType = {}));
